import React, { Component } from 'react'
import { validatePromoCode as _validatePromoCode } from '../../../services/Buyer'
import './DGPromo.less'

const initialState = {
    promoCode: '',
    promoCodeApplied: false,
    promoValidationMessage: '',
    errorApplyingPromoCode: false

}
export class DGPromo extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    onChange = (event) => {
        this.setState({ promoCode: event.currentTarget.value }, () => {
            if (_.isEmpty(this.state.promoCode)) {
                this.setState({ errorApplyingPromoCode: false });
            }
        });
    }

    removePromo = () => {
        this.setState(initialState, () => {
            this.props.onPromoRemoval();
        });
    }

    applyPromo = () => {
        if (this.state.promoCode.length > 0) {
            _validatePromoCode({ serviceID: this.props.serviceID, code: this.state.promoCode }).then((res) => {

                if (res.status && res.status === 'success') {

                    this.setState({ promoCodeValid: true, promoValidationMessage: res.data.discountMessage, promoCodeApplied: true, errorApplyingPromoCode: false }, () => {
                        this.props.onPromoApplication(this.state.promoCode);
                    });

                    /*if (this.promoCodeInputRef.current) {
                        console.log(this.promoCodeInputRef)
                        this.promoCodeInputRef.current.inputRef.current.readOnly = true;
                    }*/

                }
                else {
                    this.setState({ promoCodeValid: false, promoValidationMessage: res.message, promoCodeApplied: false, errorApplyingPromoCode: true });
                    /*if (this.promoCodeInputRef.current) {
                        this.promoCodeInputRef.current.inputRef.current.readOnly = false;
                    }*/
                }
            });
        }

    }

    applyPromoAuto = () => {
        this.setState({ promoCode: 'FIRSTPROMO' }, () => {
            this.applyPromo();
        })
    }
    render() {
        return (
            <div className="promo-container">
                {/* <div className="heading">
                    Promo Code
                </div> */}
                <div className="message">

                    {!this.state.promoCodeApplied && <div onClick={this.applyPromoAuto}>Take $15 off your first service on Dealgrace. Click here to apply promo code.</div>}
                    {this.state.promoCodeApplied && this.state.promoValidationMessage}
                </div>
                <div className="controls">
                    <input type="text" className={this.state.errorApplyingPromoCode ? 'error' : this.state.promoCodeApplied ? 'disabled' : ''} {... { disabled: this.state.promoCodeApplied }} placeholder={this.props.placeholder} onChange={this.onChange} value={this.state.promoCode}>

                    </input>

                    {!this.state.promoCodeApplied && <button type="button" onClick={this.applyPromo}>Apply</button>}
                    {this.state.promoCodeApplied && <button type="button" onClick={this.removePromo}>Remove</button>}

                    {this.state.promoCode && !_.isEmpty(this.state.promoCode) && this.state.errorApplyingPromoCode && <div className='error-label'>{this.state.promoValidationMessage}</div>}
                </div>

            </div >
        )
    }
}

export default DGPromo
